import { ReservaFiltroAdv } from "core/features/reservas/typings";
import { BaseFiltroPaginate } from "core/resources/enums/paginate";
import moment from "moment";
import { useCallback, useState } from "react";

function useFiltroMensagens() {
  const [filtro, setFiltro] = useState<ReservaFiltroAdv>({
    page: 1,
    limit: BaseFiltroPaginate.Limit,
    dataInicio: moment().format("YYYY-MM-DD"),
    dataFim: moment().add(7, "days").format("YYYY-MM-DD"),
  });

  const onChangeFiltro = useCallback((newValues: Partial<ReservaFiltroAdv>) => {
    setFiltro((prev: any) => ({ ...prev, ...newValues }));
  }, []);

  const onResetFiltro = useCallback((newValues?: Partial<ReservaFiltroAdv>) => {
    setFiltro({
      page: 1,
      limit: BaseFiltroPaginate.Limit,
      dataInicio: moment().format("YYYY-MM-DD"),
      dataFim: moment().add(7, "days").format("YYYY-MM-DD"),
      ...newValues,
    });
  }, []);

  return {
    filtro,
    setFiltro,
    onChangeFiltro,
    onResetFiltro,
  };
}

export default useFiltroMensagens;
